import Cookies from 'js-cookie';

function dataSheets() {
  const handleOutboundLinkClicks = (url, category) => {
    if (typeof ga !== 'undefined') {
      ga('send', 'event', {
        eventCategory: category,
        eventAction: 'click',
        eventLabel: url,
      });
    }
  };

  const onSafetySheetFormSubmit = e => {
    e.preventDefault();
    let form = e.currentTarget;
    const option = form.querySelector('.js-safetysheet-downloadlink');

    if (option) {
      const url = option.value;
      handleOutboundLinkClicks(url, 'Safety sheet PDF download');
      window.open(url, '_blank');
    }
  };

  const downloadPdf = (blockId, form) => {
    fetch('/api/datasheet/getpdf', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ blockId: blockId }),
    })
      .then(response => response.text())
      .then(url => {
        window.open(url, '_blank');

        if (form) {
          document.getElementById('00N2400000ITVbt').value = url;
          const emailValue = document.querySelector(
            '.js-datasheet-email',
          ).value;
          Cookies.set('has_already_downloaded_pdf', 'yes', {
            expires: 7,
            path: '/',
          });
          Cookies.set('downloaded_pdf_emailaddress', emailValue, {
            domain: '',
            path: '/',
            expires: 7,
          });
          form.removeEventListener('click', onDataSheetFormSubmit);
          form.submit();
        } else {
          handleOutboundLinkClicks(url, 'Product PDF download');
        }
      })
      .catch(function (err) {
        console.log('Fetch Error: ', err);
      });
  };

  const onProductSheetBtnClick = e => {
    let target = e.currentTarget;
    let emailFieldValue = target.previousElementSibling.value;
    const targetField = document.querySelector('.js-datasheet-email');
    targetField.value = emailFieldValue;
  };

  const onDataSheetFormSubmit = e => {
    e.preventDefault();
    let form = e.currentTarget;
    let blockId = form.dataset.blockid;
    downloadPdf(blockId, form);
  };

  const init = () => {
    const safetySheetsForm = document.querySelector('.js-safety-sheet-form');
    const dataSheetForm = document.querySelector('.js-datasheet-form');

    if (!safetySheetsForm && !dataSheetForm) return;

    const dataProductSheetContinueBtn = document.querySelector(
      '.js-datasheet-continuebutton',
    );
    const dataSheetDownloadBtn = document.querySelector(
      '.js-datasheet-downloadbutton',
    );

    if (
      Cookies.get('has_already_downloaded_pdf') === 'yes' &&
      dataProductSheetContinueBtn &&
      dataSheetDownloadBtn
    ) {
      dataProductSheetContinueBtn.classList.add('d-none');
      dataSheetDownloadBtn.classList.remove('d-none');
    }

    const cookieEmail = Cookies.get('downloaded_pdf_emailaddress');
    if (cookieEmail) {
      const firstEmailField = document.querySelector(
        '.js-datasheet-firstemail',
      );
      firstEmailField.value = cookieEmail;
    }

    if (safetySheetsForm) {
      safetySheetsForm.addEventListener('submit', onSafetySheetFormSubmit);
    }

    if (dataProductSheetContinueBtn) {
      dataProductSheetContinueBtn.addEventListener(
        'click',
        onProductSheetBtnClick,
      );
    }

    if (dataSheetDownloadBtn) {
      dataSheetDownloadBtn.addEventListener('click', function (e) {
        const blockId = e.currentTarget.dataset.blockid;
        downloadPdf(blockId, null);
      });
    }

    if (dataSheetForm) {
      dataSheetForm.addEventListener('submit', onDataSheetFormSubmit);
    }
  };

  init();
}

export default dataSheets;
